import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled, { css } from 'styled-components';
import { focusOutline } from '../../utils/mixins.js';
import { siteThemes, theme } from '../../utils/theming.js';

var DEFAULT = siteThemes.DEFAULT,
  GLOBETROTTER = siteThemes.GLOBETROTTER;
var textColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'var(--color-text)'), GLOBETROTTER, 'var(--color-quartz-550)'));
var border = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["border:1px solid var(--color-grey-400);"])), GLOBETROTTER, css(["border-bottom:1px solid var(--color-quartz-400);"])));
var borderHoverColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'var(--color-grey-600)'), GLOBETROTTER, 'var(--color-quartz-300)'));
var padding = theme('site', _defineProperty(_defineProperty({}, DEFAULT, css(["padding:8px 12px;"])), GLOBETROTTER, css(["padding:0 8px 8px 0;"])));
var labelLetterSpacing = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '0'), GLOBETROTTER, '1px'));
var labelFontSize = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '1.2rem'), GLOBETROTTER, '1.1rem'));
var arrowPositionRight = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '12px'), GLOBETROTTER, '4px'));
var SelectWrapper = styled.div.withConfig({
  displayName: "style__SelectWrapper",
  componentId: "sc-11k0i90-0"
})(["cursor:pointer;display:inline-block;font-family:var(--font-family-body);line-height:1;min-width:100px;max-width:100%;position:relative;", ""], function (props) {
  return props.$disabled && css(["cursor:default;color:var(--color-text-disabled);border:0px solid var(--color-border-disabled);"]);
});
var Select = styled.select.withConfig({
  displayName: "style__Select",
  componentId: "sc-11k0i90-1"
})(["", " bottom:0;height:100%;left:0;opacity:0;position:absolute;right:0;top:0;width:100%;color:", ";font-family:var(--font-family-body);font-size:1.6rem;", ""], padding, textColor, function (props) {
  return props.$disabled && css(["cursor:default;display:none;"]);
});
var FakeSelect = styled.div.withConfig({
  displayName: "style__FakeSelect",
  componentId: "sc-11k0i90-2"
})(["", " ", " color:", ";font-family:var(--font-family-body);font-size:1.6rem;transition:border-color var(--transition);", " ", " ", " ", ":focus-visible + &{", "}", ":hover &{", "}"], border, padding, textColor, function (props) {
  return props.$roundCorners && props.theme.site !== GLOBETROTTER && css(["border-radius:5px;"]);
}, function (props) {
  return props.$disabled && css(["border-color:var(--color-border-disabled);"]);
}, function (props) {
  return props.$invalid && css(["border-color:var(--color-element-input-error);"]);
}, Select, focusOutline, SelectWrapper, function (props) {
  return !props.$invalid && !props.$disabled && css(["border-color:", ";"], borderHoverColor);
});
var Label = styled.div.withConfig({
  displayName: "style__Label",
  componentId: "sc-11k0i90-3"
})(["color:", ";display:inline-block;font-size:", ";line-height:normal;text-overflow:ellipsis;text-transform:uppercase;letter-spacing:", ";overflow:hidden;white-space:nowrap;width:100%;", ""], textColor, labelFontSize, labelLetterSpacing, function (props) {
  return props.$disabled && css(["color:var(--color-text-disabled);"]);
});
var SelectedItem = styled.div.withConfig({
  displayName: "style__SelectedItem",
  componentId: "sc-11k0i90-4"
})(["line-height:normal;overflow:hidden;padding-right:20px;text-overflow:ellipsis;white-space:nowrap;width:100%;", " ", " .sg-select-icon{position:absolute;pointer-events:none;height:10px;width:10px;right:", ";bottom:13px;", "}"], function (props) {
  return props.theme.site === GLOBETROTTER && css(["padding-top:4px;"]);
}, function (props) {
  return props.$disabled && css(["color:var(--color-text-disabled);"]);
}, arrowPositionRight, function (props) {
  return props.$disabled && css(["color:var(--color-text-disabled);"]);
});

export { FakeSelect, Label, Select, SelectWrapper, SelectedItem };
//# sourceMappingURL=style.js.map
